import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
import ReorderButtons from '../ReorderButtons/ReorderButtons';
import styles from './ReorderableItem.module.css';

type ReorderableItemProps = {
  id: string;
  index: number;
  totalItems: number;
  onMoveUp: () => void;
  onMoveDown: () => void;
  children: ReactNode;
  containerClassName?: string;
};

const ReorderableItem: React.FC<ReorderableItemProps> = ({
  id,
  index,
  totalItems,
  onMoveUp,
  onMoveDown,
  children,
  containerClassName = ''
}) => {
  return (
    <motion.div
      key={id}
      layout
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{
        duration: 0.2,
        layout: { duration: 0.3, ease: "easeInOut" }
      }}
      className={`${styles.container} ${containerClassName}`}
    >
      <div className={styles.content}>
        {children}
      </div>
      <ReorderButtons
        onMoveUp={onMoveUp}
        onMoveDown={onMoveDown}
        canMoveUp={index > 0}
        canMoveDown={index < totalItems - 1}
      />
    </motion.div>
  );
};

export default ReorderableItem;


